import { message } from "antd";

const adminNotificationService = {
  /**
   * 📌 Admin-Notifications abrufen
   */
  getAdminNotifications: async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/adminNotifications/getAdminNotifications`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Laden der Admin-Notifications war nicht erfolgreich");
      }
      return await response.json();
    } catch (error) {
      console.error(
        "Fehler beim Abrufen der Admin-Notifications:",
        error.message
      );
      message.error(error.message);
      return [];
    }
  },

  /**
   * 📌 Eine Benachrichtigung als gelesen markieren
   */
  markOneAsRead: async (notificationId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/adminNotifications/mark`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({
            notificationId,
            adminId: localStorage.getItem("adminId"),
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Fehler beim Markieren der Benachrichtigung.");
      }

      message.success("Benachrichtigung als gelesen markiert");
    } catch (err) {
      console.error("Fehler beim Markieren der Benachrichtigung", err.message);
      message.error(err.message);
    }
  },

  /**
   * 📌 Alle Admin-Benachrichtigungen als gelesen markieren
   */
  markAllAsRead: async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/adminNotifications/mark-all`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({ adminId: localStorage.getItem("adminId") }),
        }
      );

      if (!response.ok) {
        throw new Error("Fehler beim Markieren aller Benachrichtigungen.");
      }

      message.success("Alle Benachrichtigungen als gelesen markiert");
    } catch (err) {
      console.error(
        "Fehler beim Markieren aller Benachrichtigungen",
        err.message
      );
      message.error(err.message);
    }
  },
};

export default adminNotificationService;
